import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { animateScroll as scroll, scroller } from "react-scroll";
import cn from "classnames";

import i18n from "../../../../translations/i18n";
import { openModal, closeModal } from "../../../../actions/modalActions";
import BaseModal from "../../../../components/ui/modal";
import { PAINTING_SHAPE, PAINTING_SLIDE_SCROLL } from "../../../../constants/paintingConstants";
import { PAINTING_IMAGES_MODAL } from "../../../../constants/modalConstants";


class Modal extends Component {

  constructor(props) {
    super(props);
  }

  handleScroll = () => {
    const { modal } = this.props;

    scroller.scrollTo(modal.scroll, {
      duration: 300,
      delay: 100,
      smooth: true,
      containerId: 'p-picture__gallery-modal-content',
    });
  }

  handleCloseModal = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.closeModal();
  }

  renderImages = () => {
    const { images } = this.props;

    return (
      <>
        {images.map((image, index) =>
          <div
            key={image.id}
            className="p-picture__gallery-modal-item"
            id={`${PAINTING_SLIDE_SCROLL}__${index}`}
          >
            <img
              className="p-picture__gallery-modal-image"
              src={image.original}
            />
          </div>
        )}
      </>
    )
  }

  render () {
    const { modal } = this.props;

    return (
      <BaseModal
        isOpen={modal.name === PAINTING_IMAGES_MODAL}
        onOpen={this.handleScroll}
        className={cn('p-picture__gallery-modal', {'state-active': modal.visible})}
      >
        <div className="p-picture__gallery-modal-logo">
          <a
            href="#"
            dangerouslySetInnerHTML={{__html: i18n.t('header.logo.title')}}
            onClick={this.handleCloseModal}
          />
        </div>
        <a
          href="#"
          className="p-picture__gallery-modal-close"
          title={i18n.t('modal.close.title')}
          onClick={this.handleCloseModal}
        >
          {i18n.t('modal.close.title')}
        </a>
        <div className="container">
          <div className="p-picture__gallery-modal-content" id="p-picture__gallery-modal-content">
            {this.renderImages()}
          </div>
        </div>
      </BaseModal>
    )
  }
}

Modal.propTypes = {
  painting: PropTypes.shape(PAINTING_SHAPE),
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

function mapStateToProps({layout}) {
  return {
    modal: layout.modal
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    openModal,
    closeModal,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)